export default __webpack_public_path__ + "static/media/IMG_007.9280711d.jpg";